import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import PersonalIcon from "@material-ui/icons/Person";
import SharedIcon from "@material-ui/icons/People";
import GlobalIcon from "@material-ui/icons/Public";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { Redirect } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import CloseableDialog from "../dialog/CloseableDialog";
import YesNoDialog from "../dialog/YesNoDialog";
import * as Config from "../utils/ConfigurationRegistry";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%"
    },
    avatar: {
      backgroundColor: "rgba(0, 0, 0, 0)"
    },
    textField: {
      width: "100%"
    },
    dialogTitle: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1.5),
      top: theme.spacing(1.5),
      color: theme.palette.grey[500]
    },
    formControl: {
      minWidth: 200
    },
    menuIcon: {
      marginRight: theme.spacing(1)
    }
  };
});
var ConfigurationProfileEditDialog = function ConfigurationProfileEditDialog(_ref) {
  var handleSuccess = _ref.handleSuccess,
    handleClose = _ref.handleClose,
    profileLabel = _ref.profileLabel,
    PermissionConfigurationComponent = _ref.PermissionConfigurationComponent,
    inputProfile = _ref.profile;
  var classes = useStyles();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    navigateToConfiguration = _useState2[0],
    setNavigateToConfiguration = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    profile = _useState4[0],
    setProfile = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    warningDialogOpen = _useState6[0],
    setWarningDialogOpen = _useState6[1];
  var isEditingExistingProfile = function isEditingExistingProfile() {
    return inputProfile;
  };
  useEffect(function () {
    setProfile(_objectSpread({}, inputProfile));
  }, []);
  var setName = function setName(event) {
    var profileClone = _objectSpread({}, profile);
    profileClone.name = event.target.value;
    setProfile(profileClone);
  };
  var setNotes = function setNotes(event) {
    var profileClone = _objectSpread({}, profile);
    profileClone.notes = event.target.value;
    setProfile(profileClone);
  };
  var setPermissions = function setPermissions(permissions) {
    var profileClone = _objectSpread({}, profile);
    profileClone.permission = permissions;
    setProfile(profileClone);
  };
  var handleApply = function handleApply() {
    handleSuccess(profile);
  };
  if (navigateToConfiguration) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/configuration"
    });
  }
  var isEditing = isEditingExistingProfile();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CloseableDialog, {
    title: (isEditing ? "Edit " : "Create ") + profileLabel,
    open: !warningDialogOpen,
    maxWidth: "sm",
    fullWidth: true,
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true
  }, /*#__PURE__*/React.createElement(DialogContentText, null, isEditing ? "Edit " + profileLabel + " notes" : "Create a new " + profileLabel + " by providing the name and notes"), isEditing && /*#__PURE__*/React.createElement(DialogContentText, null, "Owner: ", profile.username), /*#__PURE__*/React.createElement(TextField, {
    className: classes.textField,
    label: "Name",
    type: "text",
    disabled: isEditingExistingProfile(),
    variant: "outlined",
    value: profile.name,
    onChange: setName
  }), /*#__PURE__*/React.createElement(TextField, {
    className: classes.textField,
    label: "Notes",
    type: "text",
    variant: "outlined",
    inputProps: {
      maxLength: 500
    },
    value: profile.notes,
    onChange: setNotes
  }), PermissionConfigurationComponent && /*#__PURE__*/React.createElement(PermissionConfigurationComponent, {
    permissions: profile.permission,
    setPermissions: setPermissions
  })), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    disabled: !profile.name || profile.name === "",
    onClick: function onClick() {
      return handleApply();
    },
    color: "primary"
  }, "Apply"))));
};
export default ConfigurationProfileEditDialog;